import React from "react";

import { FlexBox } from "@braze/beacon-core";
import { useSpacing } from "@braze/beacon-styling";

import useI18nNamespace from "@services/useI18nNamespace";

import { SalesBannerWrapper, StyledButton, StyledHeading } from "./SalesBanner.style";

export const SalesBanner = () => {
  const getSpacing = useSpacing();
  const { t } = useI18nNamespace("free-trial-registration");
  const handleLogInClick = () => {
    window.open("https://www.braze.com/get-started", "_blank");
  };

  return (
    <SalesBannerWrapper data-cy="salesBanner">
      <FlexBox direction="row" justifyContent="center" gap={getSpacing("xs")}>
        <StyledHeading level={3} data-cy="salesBannerHeading">
          {t("need-help-with-your-trial-text", "Need help with your trial?")}
        </StyledHeading>
        <StyledButton data-cy="salesBannerContactLink" variant="quaternary" onClick={handleLogInClick}>
          {t("connect-with-sales-button-text", "Connect with sales")}
        </StyledButton>
      </FlexBox>
    </SalesBannerWrapper>
  );
};

export default SalesBanner;
